var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"excel-expedientes"}},[_c('custom-button',{staticClass:"mr-2",attrs:{"label":"Estatus Expedientes","iconText":"fa-file-excel","tipo":"agregar","loading":_vm.estaCargando},on:{"click":_vm.generarExcelExpedientes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }